/**
 * 标记树形数据中的节点禁用状态
 * 
 * @param {Array} treeData - 树形数据
 * @param {Array} leafIds - 允许的叶子节点ID数组
 * @param {Object} config - 配置项
 * @param {string} config.idField - ID字段名，默认为'id'
 * @param {string} config.childrenField - 子节点字段名，默认为'children'
 * @param {string} config.disabledField - 禁用字段名，默认为'disabled'
 * @returns {Array} - 处理后的树形数据
 */
export const markNonLeafNodes = (treeData, leafIds, config = {}) => {
  // 合并默认配置
  const {
    idField = "id",
    childrenField = "children",
    disabledField = "disabled"
  } = { ...config }
  
  // 递归处理节点
  const processNode = (node) => {
    // 获取子节点数组（如果有）
    const children = node[childrenField]
    
    // 检查是否为叶子节点（没有子节点）
    const isLeaf = !children || children.length === 0
    
    if (isLeaf) {
      // 处理叶子节点
      const isAllowed = leafIds.includes(node[idField])
      return {
        ...node,
        [disabledField]: !isAllowed
      }
    }
    
    // 处理非叶子节点 - 递归处理子节点
    const processedChildren = children.map(processNode)
    
    // 检查所有子节点是否都被禁用
    const allChildrenDisabled = processedChildren.every(
      child => child[disabledField] === true
    )
    
    // 创建新节点
    const newNode = {
      ...node,
      [childrenField]: processedChildren,
      [disabledField]: allChildrenDisabled
    }
    
    return newNode
  }
  
  // 处理整个树
  return treeData.map(processNode)
}